import Icon from '../components/Icon.vue'

Icon.register({
  plane: {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M480 192c35.3 0 96 28.7 96 64s-60.7 64-96 64h-114.3l-105.1 183.9c-2.8 5-8.1 8.1-13.9 8.1h-65.5c-10.6 0-18.3-10.2-15.4-20.4l49-171.6h-102.9l-43.2 57.6c-3 4-7.8 6.4-12.8 6.4h-40c-10.4 0-18-9.8-15.5-19.9l31.5-108.1-31.5-108.1c-2.5-10.1 5.1-19.9 15.5-19.9h40c5 0 9.8 2.4 12.8 6.4l43.2 57.6h102.9l-49-171.6c-2.9-10.2 4.8-20.4 15.4-20.4h65.5 0c5.1 0 11.4 3.6 13.9 8.1l105.1 183.9h114.3z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/plane.js
// module id = 1645
// module chunks = 0